export class HtmlUtil {
  public static buildFullLink(absUrl: string): string {
    return `${location.origin}${absUrl}`
  }

  public static appendMeta(name: string, content: string) {
    const meta = document.createElement('meta')

    meta.name = name
    meta.content = content

    const head = document.head || document.querySelector('head')
    if (head) {
      head.appendChild(meta)
    }
  }

  public static appendMetaViewport(
    content = 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
  ) {
    // <meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover">
    this.appendMeta('viewport', content)
  }

  public static appendScript(url: string, callback: () => void) {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    if (callback) {
      s.onload = callback
    }
    s.src = url
    document.body.appendChild(s)
  }

  public static async asyncAppendScript(url: string) {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    return new Promise<void>((resolve) => {
      s.onload = () => {
        resolve()
      }
      s.src = url
      document.body.appendChild(s)
    })
  }

  public static copyToClipboardSync(text: string) {
    return this._fallbackCopyToClipboard(text)
  }

  // 复制到粘贴板
  public static async copyToClipboard(text: string) {
    // if (navigator.clipboard) {
    //   // https://web.dev/async-clipboard/
    //   // 这个API需要用户授权
    //   return navigator.clipboard.writeText(text);
    // } else {
    return new Promise((resolve) => {
      resolve(this._fallbackCopyToClipboard(text))
    })
    // }
  }

  public static _fallbackCopyToClipboard(value: string) {
    const input = document.createElement('textarea')
    document.body.appendChild(input)
    input.contentEditable = 'true'
    input.readOnly = false
    input.value = value + ''
    input.select()

    // 兼容IOS >= 10
    // https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
    const range = document.createRange()
    if (range) {
      range.selectNodeContents(input)

      const selection = window.getSelection()
      if (selection) {
        selection.removeAllRanges()
        selection.addRange(range)
      }

      input.setSelectionRange(0, input.value.length)
    }

    try {
      return document.execCommand('copy')
    } catch (e) {
      return false
    } finally {
      document.body.removeChild(input)
    }
  }

  public static getVideoBase64(url: string) {
    return new Promise<string>(function (resolve) {
      const video = document.createElement('video')
      video.setAttribute('crossOrigin', 'anonymous') //处理跨域
      video.setAttribute('src', url)
      video.setAttribute('width', '750') /// TODO: set size
      video.setAttribute('height', '540')
      video.setAttribute('preload', 'auto')
      video.addEventListener('loadeddata', function () {
        const canvas = document.createElement('canvas')
        canvas.width = video.width
        canvas.height = video.height
        canvas.getContext('2d')?.drawImage(video, 0, 0, video.width, video.height) //绘制canvas
        resolve(canvas.toDataURL('image/jpeg')) //转换为base64
      })
    })
  }

  public static image(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.src = url
      image.onload = () => resolve(image)
      image.onerror = () => reject(image)
    })
  }

  public static download(url: string, name = '分享海报') {
    const a = document.createElement('a')
    a.download = name
    a.href = url
    a.click()
  }

  public static getFullscreenElement(): Element | null {
    const doc = document as Document & {
      mozFullScreenElement?: Element | null
      msFullScreenElement?: Element | null
      webkitFullscreenElement?: Element | null
    }
    return (
      document.fullscreenElement ??
      doc.mozFullScreenElement ??
      doc.msFullScreenElement ??
      doc.webkitFullscreenElement ??
      null
    )
  }
}
